import { QueryClient } from '@tanstack/react-query';
import { hubQueries } from '@/queries/hub';

export const hubByIdLoader = (queryClient: QueryClient) => (hubId: string) => {
  return queryClient.fetchQuery({
    ...hubQueries.item(hubId),
  });
};
